/**
 * The campaigns named on a discount row: the first, then "+N" for the rest.
 * Up to four owner-typed names used to share one line of a phone-width drawer
 * (UX-FINAL-20). Blank and repeated names are dropped first.
 */
export function campaignNamesLabel(names, t) {
  const unique = [];
  (names || []).forEach((n) => {
    const name = String(n || '').trim();
    if (name && !unique.includes(name)) unique.push(name);
  });
  if (unique.length === 0) return '';
  if (unique.length === 1) return unique[0];
  const more = t('checkout.moreCampaigns', { defaultValue: '+{{n}}', n: unique.length - 1 });
  return `${unique[0]} ${more}`;
}

export default campaignNamesLabel;
